<template>
  <div
    class="instructor-wrap text-start position-relative"
    :style="{
      backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/instructor/${info.image})`,
      // backgroundImage: `url(${image})`,
    }"
  >
    <div class="instructor-block">
      <div class="overlay"></div>
      <div class="slide-up">
        <div class="instructor h2-style mobile-h1 w-100 h-100">
          {{ seperatedName[0] }}
          <template v-if="seperatedName.length > 1">
            <br />
            {{ seperatedName[1] }}
          </template>
        </div>
        <div class="intro small-text mobile-body">{{ info.intro }}</div>
        <div class="d-flex" v-if="info.link.length > 0">
          <a :href="info.link" class="tag-link" target="_blank"
            ><img :src="linkArrow" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';

export default {
  props: {
    info: { type: Object, required: true },
    // image: { type: String },
  },
  data() {
    return {
      linkArrow,
      // bg: this.image,
    };
  },
  computed: {
    seperatedName() {
      return this.info.name.split(' ');
    },
  },
};
</script>

<style lang="stylus" scoped>
.instructor-wrap
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 460px;
  white-space: normal;

@media screen and (max-width: 575.5px)
  .instructor-wrap
    height: 300px;

    .slide-up
      padding-top: 210px;

.overlay
  position: absolute;
  // bottom: 100%;
  opacity: 0;
  left: 0;
  right: 0;
  background-color: rgba(244, 243, 238, 0.8);
  overflow: hidden;
  width: 100%;
  // height: 0;
  // transition: all 0.3s ease-in-out;

.instructor-block
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover
    // background-color: rgba(244, 243, 238, 0.8);
    .overlay
      opacity: 0.85;
      height: 100%;
      mix-blend-mode: alpha;
      transition: all 0.5s ease-out;

    .slide-up
      transition: all 0.5s ease-out;
      color: $monoc4;
      padding-top: 16px;

.slide-up
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: $monoc1;
  padding: 360px 16px 16px 16px;
  z-index: 500;
  transition: all 0.5s ease-in-out;

.intro
  margin-top: 24px;
  margin-bottom: 16px;
  text-align: justify;

  &.out
    margin-top: 180px;
    width: 100%;

.tag-link
  margin-top: 24px;

  img
    width: 36px;
    margin-left: 8px;
</style>
